import { Card, CardContent, Tag, Typography } from '@volvo/vcdk-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';

const RoleTypes: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Card>
      <CardContent>
        <Typography variant="heading4" className="mb-9">
          {t(($) => $.components.role_types.title)}
        </Typography>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          <div className="flex flex-col gap-5">
            <Tag variant="neutral-subtle">{t(($) => $.components.role_types.manager.title)}</Tag>
            <Typography>{t(($) => $.components.role_types.manager.description)}</Typography>
          </div>
          <div className="flex flex-col gap-5">
            <Tag variant="neutral-subtle">{t(($) => $.components.role_types.technician.title)}</Tag>
            <Typography>{t(($) => $.components.role_types.technician.description)}</Typography>
          </div>
          <div className="flex flex-col gap-5">
            <Tag variant="neutral-subtle">{t(($) => $.components.role_types.viewer.title)}</Tag>
            <Typography>{t(($) => $.components.role_types.viewer.description)}</Typography>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default withComponentErrorBoundary(RoleTypes);
